import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { Otp } from "../../../legal/Otp";
import { PrimaryMobile } from "../../../buttons/mobile/Primary";

export function VerifyNewEmail({
  email,
  showViewVerifyOtp,
  disabledBtn,
  setOptInput,
  handleSubmitVerifyOtp,
  messageError,
  showError,
  handleClosePanel
}) {

  return (
    <>
      {
        <Dialog open={showViewVerifyOtp} onClose={() => handleClosePanel()} className="relative z-50">
          <DialogBackdrop
            transition
            className="fixed inset-0 transition-opacity duration-200 ease-in-out data-[closed]:opacity-0"
          />

          <div className="fixed inset-x-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
                <DialogPanel
                  transition
                  className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-[closed]:translate-x-full"
                >
                  <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                    <div className="">
                      <div className="py-6 bg-darkBg">
                        <div className="flex justify-between px-4 pt-8 ">
                          <div className="flex h-7 items-center">
                            <button
                              type="button"
                              onClick={() => handleClosePanel()}
                              className="relative text-white focus:outline-none"
                            >
                              <span className="absolute" />
                              <span className="sr-only">Cerrar</span>
                              <ArrowLeftIcon
                                aria-hidden="true"
                                className="h-6 w-6"
                              />
                            </button>
                          </div>
                          <DialogTitle>
                            <div className="text-white">Email</div>
                          </DialogTitle>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              onClick={() => handleClosePanel()}
                              className="relative text-white focus:outline-none"
                            >
                              <span className="absolute" />
                              <span className="sr-only">Cerrar</span>
                              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                            </button>
                          </div>
                        </div>
                        <div className=" px-4 pt-8 ">
                          <div className="text-white font-bold text-xl">
                            Verificación de seguridad
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="h-full rounded-t-3xl bg-white p-4">
                      <div className="text-grayP py-4">
                        Digita el código de 6 dígitos que hemos enviado a tu
                        correo {email.substring(5, 0) + "*****" + email.split('@')[1]} .
                      </div>
                      <div className="text-center block">
                        <Otp name="tokensms" id="tokensms" setOptInput={setOptInput} />
                      </div>

                      {showError && (<div className="flex justify-center"> <span className="text-sm text-red pt-2" >{messageError}</span> </div>)}

                      <div className={"w-full"}>
                        <div className="cursor-pointer min-w-full pt-2" onClick={handleSubmitVerifyOtp}>
                          <div className="flex justify-end">
                            <PrimaryMobile
                              disabled={disabledBtn}
                              icon={<ArrowRightIcon className="w-6 h-auto" />}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </div>
        </Dialog>
      }

    </>
  );
}
